import { PermissionListModel } from '../services/api-client';

export interface PermissionListViewModel extends PermissionListModel {
  scopeParameterFilterValue: string;
}

export function createPermissionListViewModel(permission: PermissionListModel): PermissionListViewModel {
  return {
    ...permission,
    scopeParameterFilterValue: permission.scopeParameters
      .map((parameter) =>
        [parameter.name.value, parameter.value.description, parameter.value.value].filter(Boolean).join(' ')
      )
      .join(' '),
  };
}
